import { useEffect, useState } from 'react';

function useIsExternalUser(ProductPageState) {
  const [isExternalUser, setIsExternalUser] = useState(false);
  const isPDPExternalVisitorEnabled = ProductPageState?.collectionData?.isPDPExternalVisitorEnabled;

  useEffect(() => {
    const paramNames = ['cmp', 'source', 'utm_source'];
    const searchParams = new URLSearchParams(window.location.search);

    paramNames.forEach((paramName) => {
      if (searchParams.has(paramName) && isPDPExternalVisitorEnabled) {
        setIsExternalUser(true);
      }
    });
  }, [isPDPExternalVisitorEnabled]);

  return isExternalUser;
}

export default useIsExternalUser;
